import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.title',
		defaultMessage: 'Customer notification logs',
		description: 'Page Title description',
	},
	projects: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.projects',
		defaultMessage: 'Projects',
		description: 'Breadcrumb starts from Projects',
	},
});
